module.exports = __webpack_public_path__ + "img/37315-074.d8be1052.jpg";